import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-inventario-inventario',
  templateUrl: './lista.component.html'
})

export class InventarioComponent{
  tamano = document.body.clientHeight;
  datos = [];
  cargando = false;

}